export const ChatRoute = '/chat';
export const ExploreGptRoute = '/explore';
export const ExploreGptSummaryRoute = '/explore/:id';
export const PersonalGptRoute = '/personalgpt';
export const PersonalGptSpecificRoute = '/personalgpt/:id';
export const ChatSpecificRoute = '/chat/:id';
export const SettingsRoute = '/settings';
export const SettingsConversationsRoute = '/settings/chats';
export const SettingsUserManagementRoute = '/settings/user-management';
export const SettingsSurveysRoute = '/settings/surveys';
export const SettingsSurveysNewRoute = '/settings/surveys/new';
export const SettingsSurveysEditRoute = '/settings/surveys/edit/:id';
export const SettingsSurveysViewRoute = '/settings/surveys/view/:id';
export const AdminSettingsRoute = '/adminsettings';
export const ErrorRoute = '/error';

export const buildRoute = (routePattern: string, routeParams: { [key: string]: string }, separator: string = ':') => {
    let route = routePattern;
    Object.keys(routeParams).forEach((key) => {
        const paramValue = routeParams[key];
        route = route.replace(`${separator}${key}`, paramValue);
    });
    return route;
};
